import React from 'react';

export default React.memo(function Label({ className = '', label, required, children }) {
  return (
    <label className={className}>
      <span
        className={`text-neutral ${required ? `after:content-['*'] after:text-red-300 after:ml-0.5` : ''}`}>{label}</span>
      {children}
    </label>
  );
})
